export default __webpack_public_path__ + "static/media/gradient.6d5e3ebb.png";